import { styled } from '@mui/material/styles';
import MuiTextField from '@mui/material/TextField';

export const TextField = styled(MuiTextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        borderRadius: 8,
        fontSize: 14,
        '& fieldset': {
            borderWidth: 1,
        },
        '&:hover fieldset': {
            borderWidth: 1,
        },
        '&.Mui-focused fieldset': {
            borderWidth: 1,
        },
    },
}));
